import type * as signalR from '@microsoft/signalr';
import { type IStreamRegistration, ServiceConnectedState, type WebsocketStore } from './WebsocketStore';
import { StoreBase } from '../Types/StoreBase';

export class StreamRegistration<T = any> extends StoreBase implements IStreamRegistration {
    private _subscription?: signalR.ISubscription<T>;
    private _eventSocket: WebsocketStore;
    private _methodName: string;
    private _args: any[];
    private _streamSubscriber?: signalR.IStreamSubscriber<T>;

    constructor(eventSocket: WebsocketStore, methodName: string, ...args: any[]) {
        super();
        this._methodName = methodName;
        this._args = args;
        this._eventSocket = eventSocket;

        this._disposers.push(
            eventSocket.observeConnectionChange((socketState) => {
                if (socketState === ServiceConnectedState.Online) {
                    this.runSubscribe();
                } else {
                    this.unsubscribe();
                }
            })
        );

        this._disposers.push(() => {
            this.unsubscribe();
        });
    }

    subscribe(subscriber: signalR.IStreamSubscriber<T>) {
        this._streamSubscriber = subscriber;
        this.runSubscribe();

        return this;
    }

    private runSubscribe() {
        this.unsubscribe();
        if (!this._streamSubscriber) {
            return;
        }
        this._subscription = this._eventSocket.stream<T>(this._methodName, ...this._args)?.subscribe(this._streamSubscriber);
    }

    private unsubscribe() {
        try {
            if (this._subscription) {
                this._subscription.dispose();
            }
        } catch (err) {
            console.log({ err });
        }
    }
}
